import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import {  POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetFlashStatusRequest } from './getflashstatusrequest';

export class GetFlashStatusAPI extends SixdeeCRBTAPI<GetFlashStatusRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }
    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/get-status";
    }

    protected getRequestData() {
        return {
            "msisdn": this.getRequest().getMsisdn()
        };
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashstatus/getflashstatusapi.tsx